import { FC, ReactNode } from 'react';
import { ContentDismissalContext } from '@moment/analytics/ContentDismissalContext';
import { ContentDismissalService } from '@moment/analytics/ContentDismissalService';

interface ContentDismissalProviderProps {
  service: ContentDismissalService;
  children: ReactNode;
}

export const ContentDismissalProvider: FC<ContentDismissalProviderProps> = ({ service, children }) => {
  return (
    <ContentDismissalContext.Provider value={service}>
      {children}
    </ContentDismissalContext.Provider>
  );
};
